module.exports = __webpack_public_path__ + "static/media/sayali_khedkar.2abfc509.png";